import { API_BASE_URL } from '../../../../api';
import React, { useContext, useEffect, useState } from "react";
import './locations.style.scss';
import { AccountContext } from '../../../../Contexts/main.context';
import { setButtons } from "../../../../Functions/theFunctions";

const ClientLocations = () => {

    

     const context = useContext(AccountContext);
     const { activeClient, clientAccounts, updateClientAccounts, originalID, updateMasked, updateActiveClient, updateActionButtons,actionButtons,updateActiveOutlet } = context || {};

     const [arrayOfLocations, setArrayOfLocations] = useState([]);
     const [savedClient, updateTheClient] = useState([]);

     useEffect(() => {
          if (activeClient && clientAccounts.length > 0) {
               const matchingClients = clientAccounts.filter(client =>
                    client.ID === originalID || client.locationID === originalID
               );
               setArrayOfLocations(matchingClients);
          }

          updateTheClient(activeClient);
     }, [clientAccounts, activeClient,originalID]);

     const createClient = async () => {
          updateMasked(false);
          const sendData = { ID: savedClient.ID, script: "createLocation" };
          try {
               const response = await fetch(API_BASE_URL + 'special.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(sendData),
               });

               const data = await response.json();
               if (data.status === "success") {
                    const newCount = data.clientArray.filter(data => data.locationID === originalID);
                    const oldRecord = data.clientArray.find(needle => needle.ID === originalID);
                    const locationCount = newCount.length; 
                    if (oldRecord) {
                         oldRecord.LocationCount = locationCount;
                     }
                    updateClientAccounts(data.clientArray);
                    const changedAB = actionButtons.find(bb=>bb.action === 'ViewLocation');
                    changedAB.label = `Locations (${locationCount + 1})`;
                    updateActionButtons(actionButtons);
               } else {
                    alert("Error saving client.");
               }
          } catch (error) {
               alert("An error occurred Saving Data");
          }
     };

     const cancelNew = () => {
          updateMasked(false);
     };

     const handleCreateClick = () => {
          updateMasked(true);
          if (window.confirm("Are you sure you want to create a Location with no address, etc?")) {
               createClient();
          } else {
               cancelNew();
          }
     };

     const setCurrent = async (locationID) => {
          const selectedLocation = clientAccounts.find(client => String(client.ID) === String(locationID));
          if (!selectedLocation) return;

          const locationCount = clientAccounts.filter(client => String(client.locationID) === String(originalID)).length;
          updateActiveClient(selectedLocation);
          updateActiveOutlet('ViewCitations');

          const buttons = await setButtons('ClientData', locationCount, selectedLocation.citationCount);
          updateActionButtons(buttons.map(button => ({
               ...button,
               selected: button.action === 'ViewCitations',
          })));
     };

     return (
          <>
               <div className="col-46 offset-1 rounded-2">
                    <div className="p-2 text-center fs-4 text-navy fw-bold mb-2">
                         Current Location - {activeClient.companyName} - {activeClient.theLocation}
                    </div>

                    <div className="d-flex flex-wrap gap-1 justify-content-center">
                         {arrayOfLocations.map((location, index) => (
                              <div
                                   key={index}
                                   className={`location-card p-1 col-11 mb-3 ${location.ID === activeClient.ID ? 'bg-navy' : 'bg-primary'}`}
                                   onClick={()=>setCurrent(location.ID)}>
                                   <div className="text-center fw-bold h4 text-white mt-2">{location.companyName}</div>
                                   <div className="fs-5 text-center fw-bold text-lemon mb-1">
                                        {location.theLocation}
                                   </div>
                                   <div className="fs-5 text-center text-white">
                                        {location.city} {location.postal}
                                   </div>
                                   <div className="w-100 p-1">
                                        <div className="text-center h1 text-white">{location.citationCount} <span className="fs-8">Citations</span></div>
                                   </div>
                                   {/* <div className="mt-1 text-center fs-5">{location.city}, {location.province} - {location.postal}</div>
                                   <div className="mt-1 justify-content-center fs-5 d-flex gap-4">
                                        <div>Contact: {location.contactName || 'N/A'}</div>
                                        <div>Phone: {location.phone || 'N/A'}</div>
                                   </div> */}
                                   {/* <div className="mt-1 text-center fs-5">Website: {location.website || 'N/A'}</div> */}
                              </div>
                         ))}

                         {/* Create New Location Box */}
                         <div
                              className="location-card col-11 mb-3 alert-success create-location-box"
                              onClick={handleCreateClick}
                              style={{ border: "3px dotted green", cursor: "pointer" }}
                         >
                              <div className="text-center">
                                   {/* SVG Plus Icon */}
                                   <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 5v14M5 12h14" stroke="green" strokeWidth="2" strokeLinecap="round" />
                                   </svg>

                                   <div className="fw-bold h5 mt-3">Create New Location</div>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     );
};

export default ClientLocations;
